
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { panoramicQueryServer, zyScreenServer } from '@/api/installServer';
import Dialog2 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box3/dialog-2.vue';

@Component({
  components: { Dialog2 },
})
export default class CorrectRate extends Vue {
  options: any = [];
  dialogVisible: any = false;
  tableData: any = [];
  private timeRange: any = '';

  total: any = '';
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  formData: any = {
    type: '',
    deptId: '',
  };

  showDialog(data: any) {
    this.formData.deptId = data.deptId ? data.deptId : '';
    this.formData.type = data.type;
    this.getData();
    this.dialogVisible = true;
  }

  handleClose(done: any) {
    done();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }
  changeDate() {
    (this.queryDataForm as any).pageNo = 1;
    this.getData();
  }

  getData() {
    zyScreenServer
      .getWorkListData({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        taskUnitId: this.formData.deptId,
        type: this.formData.type,
        startTime: this.timeRange ? (this.timeRange[0] ? this.timeRange[0] : null) : null,
        endTime: this.timeRange ? (this.timeRange[1] ? this.timeRange[1] : null) : null,
      })
      .then((res: any) => {
        this.total = res.data.total;
        this.tableData = res.data.records;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  showDetail(item: any) {
    const refName = 'Dialog2Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }
}
